export default __webpack_public_path__ + "static/media/grafema_design-factory-kitchen-pictograms_05.7491eab6.jpg";